

const RetailerTags = () => {

  return <div></div>
}

export default RetailerTags;
